import { createUseStyles } from 'react-jss';
import colors from '@insurancemenu/imenu-components-lib/dist/utils/colors';

const styles = {
  actionButton: {
    height: '4.4rem',
    backgroundColor: colors.neutral.white,
    color: colors.neutral[900],
    font: { size: '1.6rem', lineHeight: '2.4rem', weight: 700 },
    textDecoration: 'underline',
    marginBottom: '5rem',
  },
  modalContent: {
    padding: '0 2rem',
    textAlign: 'left',
  },
  modalText: {
    font: { size: '1.6rem', lineHeight: '2.4rem', weight: 700 },
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
